import { render } from "./CandidateTable.vue?vue&type=template&id=2f22d64b&scoped=true"
import script from "./CandidateTable.vue?vue&type=script&lang=js"
export * from "./CandidateTable.vue?vue&type=script&lang=js"

import "./CandidateTable.vue?vue&type=style&index=0&id=2f22d64b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f22d64b"]])

export default __exports__